module.exports = __webpack_public_path__ + "assets/img/EKSElement-last-station.6bcbfaf1.svg";